import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import BackToTop from '@/components/base/BackToTop';

export default function Layout() {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <>
      <ScrollToTop />
      <Navbar />
      {!isHome && <Breadcrumb />}
      <main>
        <Outlet />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}